// Static location data with devices
export const locationsData = [
  {
    name: "BIG",
    fullName: "West Woodlawn",
    city: "Chicago",
    siteType: "Urban Park",
    coordinates: [41.777021702, -87.609711317],
    mfrNodes: ["MNLA4O10A", "MNLA4O10B", "MNLA4O10C"],
    sapFlowMeters: ["SX61NA0U", "SX61P301", "SX61NA0I"],
    overview: {
      registration: "9/20/2023, 12:10:34 PM",
    },
    devices: [
      { 
        name: "MFR_node_MNLA4O10A",
        serialNumber: "MNLA4O10A",
        devEUI: "379afb6f83da6653",
        site: "Champlain",
        type: "MFR Node",
        coordinates: [41.778703, -87.609806],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },
      { 
        name: "MFR_node_MNLA4O10B",
        serialNumber: "MNLA4O10B",
        devEUI: "eca11baaeac43cba",
        site: "Delta",
        type: "MFR Node",
        coordinates: [41.777239, -87.608681],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },
      { 
        name: "MFR_node_MNLA4O10C",
        serialNumber: "MNLA4O10C",
        devEUI: "2cc17e2d7cb601a2",
        site: "Langley",
        type: "MFR Node",
        coordinates: [41.778769, -87.608217],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },
      { 
        name: "Sap_Flow_Meter_SX61NA0U",
        serialNumber: "SX61NA0U",
        devEUI: "44bf2806b70c2311",
        treeId: "0001",
        treeSpecies: "Maple",
        treeDiameter: "107 cm",
        type: "Sap Flow Sensor",
        coordinates: [41.77858, -87.611219],
      },
      { 
        name: "Sap_Flow_Meter_SX61P301",
        serialNumber: "SX61P301",
        devEUI: "TBD",
        treeId: "0002",
        treeSpecies: "Elm",
        treeDiameter: "75.5 cm",
        type: "Sap Flow Sensor",
        coordinates: [41.7772, -87.60858],
      },
      { 
        name: "Sap_Flow_Meter_SX61NA0I",
        serialNumber: "SX61NA0I",
        devEUI: "56de24386bd33383",
        treeId: "0003",
        treeSpecies: "Tree of Heaven",
        treeDiameter: "74 cm",
        type: "Sap Flow Sensor",
        coordinates: [41.778732, -87.609843],
      },
      {
        name: "WXT536_Sensor_WXT-BIG",
        serialNumber: "WXT-BIG",
        devEUI: "",
        site: "Rooftop",
        type: "WXT536 Sensor",
        coordinates: [41.776953965, -87.609769326],
      },
      {
        name: "AQT530_Sensor_AQT-BIG",
        serialNumber: "AQT-BIG",
        devEUI: "",
        site: "Rooftop",
        type: "AQT530 Sensor",
        coordinates: [41.776953965, -87.609769326],
      },
    ],
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  {
    name: "CSU",
    fullName: "Chicago State University",
    city: "Chicago",
    siteType: "Urban",
    coordinates: [41.71995827, -87.612900518],
    mfrNodes: ["MNLA4O102", "MNLA4O103"],
    sapFlowMeters: ["SX61NA0P", "SX61NA0E", "SX61NA08", "SX61NA0T", "SX61NA0A", "SX61NA0Z"],
    overview: {
      registration: "6/13/2022, 1:28:01 PM",
    },
    devices: [
      {
        name: "MFR_node_MNLA4O102",
        serialNumber: "MNLA4O102",
        devEUI: "4356d0b69a8e08c8",
        site: "Non-Prairie",
        type: "MFR Node",
        coordinates: [41.719631, -87.612884],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },
      {
        name: "MFR_node_MNLA4O103",
        serialNumber: "MNLA4O103",
        devEUI: "7e7c529d7aa54a18",
        site: "Prairie",
        type: "MFR Node",
        coordinates: [41.719892, -87.613022],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0P",
        serialNumber: "SX61NA0P",
        devEUI: "8C1F6460E80000D2",
        treeId: "104",
        treeSpecies: "American Elm",
        treeDiameter: "32.5 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.71899, -87.61238],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0E",
        serialNumber: "SX61NA0E",
        devEUI: "8C1F6460E80000D9",
        treeId: "105",
        treeSpecies: "American Elm",
        treeDiameter: "64.8 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.71909, -87.61168],
      },
      {
        name: "Sap_Flow_Meter_SX61NA08",
        serialNumber: "SX61NA08",
        devEUI: "8c1f6460e80000a6",
        treeId: "106",
        treeSpecies: "Maple",
        treeDiameter: "34.25 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.72064, -87.61392],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0T",
        serialNumber: "SX61NA0T",
        devEUI: "8c1f6460e80000f9",
        treeId: "107",
        treeSpecies: "Maple",
        treeDiameter: "38 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.72022, -87.61392],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0A",
        serialNumber: "SX61NA0A",
        devEUI: "8c1f6460e80000f1",
        treeId: "108",
        treeSpecies: "Maple",
        treeDiameter: "22.25 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.72046, -87.61391],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0Z",
        serialNumber: "SX61NA0Z",
        devEUI: "e2cf573b90232d64",
        treeId: "109",
        treeSpecies: "American Elm",
        treeDiameter: "44.2 cm",
        type: "Sap Flow Sensor",
        coordinates: [41.71886, -87.61136],
      },
      {
        name: "Band_Dendrometer_SNLA4P301",
        serialNumber: "SNLA4P301",
        devEUI: "98208e00000346e8",
        treeId: "107",
        treeSpecies: "Maple",
        treeDiameter: "38 inches",
        type: "Band Dendrometer",
        coordinates: [41.72022, -87.61392],
      },
      {
        name: "Band_Dendrometer_SNLA4P302",
        serialNumber: "SNLA4P302",
        devEUI: "98208e00000346e9",
        treeId: "108",
        treeSpecies: "Maple",
        treeDiameter: "22.25 inches",
        type: "Band Dendrometer",
        coordinates: [41.72046, -87.61391],
      },
      {
        name: "Band_Dendrometer_SNLA4P304",
        serialNumber: "SNLA4P304",
        devEUI: "98208e00000346e7",
        treeId: "106",
        treeSpecies: "Maple",
        treeDiameter: "34.25 inches",
        type: "Band Dendrometer",
        coordinates: [41.72064, -87.61392],
      },
      {
        name: "WXT536_Sensor_WXT-CSU",
        serialNumber: "WXT-CSU",
        devEUI: "",
        site: "Prairie",
        type: "WXT536 Sensor",
        coordinates: [41.719837344, -87.61285851],
      },
      {
        name: "AQT530_Sensor_AQT-CSU",
        serialNumber: "AQT-CSU",
        devEUI: "",
        site: "Prairie",
        type: "AQT530 Sensor",
        coordinates: [41.719837344, -87.61285851],
      },
    ],
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  {
    name: "IBP",
    fullName: "Indian Boundary Prairies",
    city: "Markham",
    siteType: "Suburban",
    coordinates: [41.608145186, -87.704647595],
    mfrNodes: ["MNLA4010D"],
    sapFlowMeters: [],
    overview: {
      registration: "5/14/2025, 9:47:28 AM",
    },
    devices: [
      {
        name: "MFR_node_MNLA4010D",
        serialNumber: "MNLA4010D",
        devEUI: "20344d23dd09ca17",
        site: "Prarie",
        type: "MFR Node",
        coordinates: [41.604759, -87.690459],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },
    ],
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  {
    name: "NEIU",
    fullName: "Northeastern Illinois University",
    city: "Chicago",
    siteType: "Urban",
    coordinates: [41.98053299237866, -87.71662374616044],
    mfrNodes: ["MNLA4O107", "MNLA4O108"],
    sapFlowMeters: ["SX61NA0M", "SX61NA0X", "SX61NA0V", "SX61NA01", "SX61NA0J", "SX61NA0N"],
    overview: {
      registration: "6/13/2022, 1:28:01 PM",
    },
    devices: [
      {
        name: "MFR_node_MNLA4O107",
        serialNumber: "MNLA4O107",
        devEUI: "1435db497f628cbb",
        site: "North",
        type: "MFR Node",
        coordinates: [41.981459, -87.7173],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54"],
      },
      {
        name: "MFR_node_MNLA4O108",
        serialNumber: "MNLA4O108",
        devEUI: "2bb2d7ff13d46ca2",
        site: "South",
        type: "MFR Node",
        coordinates: [41.977505, -87.716479],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54"],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0M",
        serialNumber: "SX61NA0M",
        devEUI: "1803B578CDD29E90",
        treeId: "6376",
        treeSpecies: "Swamp White Oak",
        treeDiameter: "69.1cm",
        type: "Sap Flow Sensor",
        coordinates: [41.97747, -87.716519],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0X",
        serialNumber: "SX61NA0X",
        devEUI: "9F3F32B191DE3E7B",
        treeId: "6377",
        treeSpecies: "Swamp White Oak",
        treeDiameter: "59.8cm",
        type: "Sap Flow Sensor",
        coordinates: [41.97742, -87.716587],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0V",
        serialNumber: "SX61NA0V",
        devEUI: "1E6B4625D064765D",
        treeId: "6091",
        treeSpecies: "American Elm",
        treeDiameter: "65.6cm",
        type: "Sap Flow Sensor",
        coordinates: [41.97905, -87.716171],
      },
      {
        name: "Sap_Flow_Meter_SX61NA01",
        serialNumber: "SX61NA01",
        devEUI: "796E604CFB49E4CB",
        treeId: "2092",
        treeSpecies: "Sugar Maple",
        treeDiameter: "50.9cm",
        type: "Sap Flow Sensor",
        coordinates: [41.98138, -87.717416],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0J",
        serialNumber: "SX61NA0J",
        devEUI: "C64295B0179877F4",
        treeId: "2096",
        treeSpecies: "Sugar Maple",
        treeDiameter: "46.5cm",
        type: "Sap Flow Sensor",
        coordinates: [41.98137, -87.7174],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0N",
        serialNumber: "SX61NA0N",
        devEUI: "0722A914DBFC09EF",
        treeId: "2104",
        treeSpecies: "Sugar Maple",
        treeDiameter: "35.3cm",
        type: "Sap Flow Sensor",
        coordinates: [41.98144, -87.717564],
      },
      {
        name: "Band_Dendrometer_SNLA4P307",
        serialNumber: "SNLA4P307",
        devEUI: "98208e0000034716",
        treeId: "2092",
        treeSpecies: "Sugar Maple",
        treeDiameter: "50.9cm",
        type: "Band Dendrometer",
        coordinates: [41.98138, -87.717416],
      },
      {
        name: "Band_Dendrometer_SNLA4P308",
        serialNumber: "SNLA4P308",
        devEUI: "98208e0000034717",
        treeId: "2096",
        treeSpecies: "Sugar Maple",
        treeDiameter: "46.5cm",
        type: "Band Dendrometer",
        coordinates: [41.98137, -87.7174],
      },
      {
        name: "WXT536_Sensor_WXT-NEIU",
        serialNumber: "WXT-NEIU",
        devEUI: "",
        site: "Rooftop",
        type: "WXT536 Sensor",
        coordinates: [41.98053299237866, -87.71662374616044],
      },
      {
        name: "AQT530_Sensor_AQT-NEIU",
        serialNumber: "AQT-NEIU",
        devEUI: "",
        site: "Rooftop",
        type: "AQT530 Sensor",
        coordinates: [41.98053299237866, -87.71662374616044],
      },
    ],
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  {
    name: "NU",
    fullName: "Northwestern University",
    city: "Evanston",
    siteType: "Suburban",
    coordinates: [42.05142506, -87.677642818],
    mfrNodes: ["MNLA4O104"],
    sapFlowMeters: ["SX61NA0Y", "SX61NA0F", "SX61NA07", "SX61NA0G", "SX61NA0L", "SX61NA0Q"],
    overview: {
      registration: "6/13/2022, 1:28:01 PM",
    },
    devices: [
      {
        name: "MFR_node_MNLA4O104",
        serialNumber: "MNLA4O104",
        devEUI: "ff79225ef576b420",
        site: "Grove",
        type: "MFR Node",
        coordinates: [42.05258, -87.67682],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0Y",
        serialNumber: "SX61NA0Y",
        devEUI: "92AB513A539C22AE",
        treeId: "3478",
        treeSpecies: "Maple",
        treeDiameter: "85.7 inch",
        type: "Sap Flow Sensor",
        coordinates: [42.0527, -87.67702],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0F",
        serialNumber: "SX61NA0F",
        devEUI: "1CF607E9A19C335A",
        treeId: "3607",
        treeSpecies: "Maple",
        treeDiameter: "36.5 inch",
        type: "Sap Flow Sensor",
        coordinates: [42.05225, -87.67633],
      },
      {
        name: "Sap_Flow_Meter_SX61NA07",
        serialNumber: "SX61NA07",
        devEUI: "F8F31258AFD84491",
        treeId: "3590",
        treeSpecies: "Oak",
        treeDiameter: "75.2 inch",
        type: "Sap Flow Sensor",
        coordinates: [42.05234, -87.67655],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0G",
        serialNumber: "SX61NA0G",
        devEUI: "326C7B6766E491AF",
        treeId: "4416",
        treeSpecies: "Oak",
        treeDiameter: "25.2 inch",
        type: "Sap Flow Sensor",
        coordinates: [42.05208, -87.67662],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0L",
        serialNumber: "SX61NA0L",
        devEUI: "B47ECB6B3713A483",
        treeId: "4417",
        treeSpecies: "Maple",
        treeDiameter: "49.3 inch",
        type: "Sap Flow Sensor",
        coordinates: [42.051362, -87.678114],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0Q",
        serialNumber: "SX61NA0Q",
        devEUI: "D613C900357C2C49",
        treeId: "4418",
        treeSpecies: "Maple",
        treeDiameter: "71.1 inch",
        type: "Sap Flow Sensor",
        coordinates: [42.051617, -87.678233],
      },
      {
        name: "Band_Dendrometer_SNLA4P305",
        serialNumber: "SNLA4P305",
        devEUI: "98208e00000346ec",
        treeId: "3607",
        treeSpecies: "Sugar Maple",
        treeDiameter: "36.5 inch",
        type: "Band Dendrometer",
        coordinates: [42.05225, -87.67633],
      },
      {
        name: "Band_Dendrometer_SNLA4P306",
        serialNumber: "SNLA4P306",
        devEUI: "98208e00000345c9",
        treeId: "4417",
        treeSpecies: "Red Maple",
        treeDiameter: "49.3 inch",
        type: "Band Dendrometer",
        coordinates: [42.051362, -87.678114],
      },
      {
        name: "WXT536_Sensor_WXT-NU",
        serialNumber: "WXT-NU",
        devEUI: "",
        site: "Rooftop",
        type: "WXT536 Sensor",
        coordinates: [42.051407767, -87.677659396],
      },
      {
        name: "AQT530_Sensor_AQT-NU",
        serialNumber: "AQT-NU",
        devEUI: "",
        site: "Rooftop",
        type: "AQT530 Sensor",
        coordinates: [42.051407767, -87.677659396],
      },
    ],
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  {
    name: "UIC",
    fullName: "University of Illinois Chicago",
    city: "Chicago",
    siteType: "Urban",
    coordinates: [41.869384335, -87.645820232],
    mfrNodes: ["MNLA4O105", "MNLA4O106"],
    sapFlowMeters: ["SX61NA0M", "SX61NA05", "SX61NA0R", "SX61NA0B", "SX61NA0S", "SX61NA0K", "SX61NA0O", "SX61NA0D", "SX61NA0W"],
    overview: {
      registration: "9/6/2023, 12:39:08 PM",
    },
    devices: [
      {
        name: "MFR_node_MNLA4O105",
        serialNumber: "MNLA4O105",
        devEUI: "d27ca80ed1a2bc1a",
        site: "Greenhouse",
        type: "MFR Node",
        coordinates: [41.869385, -87.645848],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54"],
      },
      {
        name: "MFR_node_MNLA4O106",
        serialNumber: "MNLA4O106",
        devEUI: "6634d7f45ef631e6",
        site: "Parking Lot 5",
        type: "MFR Node",
        coordinates: [41.868385, -87.649106],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },
      {
        name: "MFR_node_MNLA4O10E",
        serialNumber: "MNLA4O10E",
        devEUI: "6634d7f45ef631e6",
        site: "Lab",
        type: "MFR Node",
        coordinates: [41.868385, -87.649106],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },      
      {
        name: "Sap_Flow_Meter_SX61NA0M",
        serialNumber: "SX61NA0M",
        devEUI: "E5005FD11BA30529",
        treeId: "2503",
        treeSpecies: "Honey Locust",
        treeDiameter: "56 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.87075402, -87.64720783],
      },
      {
        name: "Sap_Flow_Meter_SX61NA05",
        serialNumber: "SX61NA05",
        devEUI: "78FF3BAEBB1EC41F",
        treeId: "1731",
        treeSpecies: "Honey Locust",
        treeDiameter: "66.5 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.86914307, -87.64673859],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0R",
        serialNumber: "SX61NA0R",
        devEUI: "A7ECBD8493E70DC8",
        treeId: "1763",
        treeSpecies: "Honey Locust",
        treeDiameter: "79.75 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.86945762, -87.64565319],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0B",
        serialNumber: "SX61NA0B",
        devEUI: "25332B0AC21B4095",
        treeId: "1727",
        treeSpecies: "American Elm",
        treeDiameter: "34 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.86949402, -87.64649513],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0S",
        serialNumber: "SX61NA0S",
        devEUI: "3FD2498D8A3CAB1F",
        treeId: "2867",
        treeSpecies: "Maple",
        treeDiameter: "57.8 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.86810862, -87.64869461],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0K",
        serialNumber: "SX61NA0K",
        devEUI: "33B28E6711F57D6B",
        treeId: "1777",
        treeSpecies: "Maple",
        treeDiameter: "85.2 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.86895894, -87.64665977],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0O",
        serialNumber: "SX61NA0O",
        devEUI: "9E5060E372393705",
        treeId: "2114",
        treeSpecies: "American Elm",
        treeDiameter: "50.8 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.86945244, -87.64733949],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0D",
        serialNumber: "SX61NA0D",
        devEUI: "53676649ED4F9771",
        treeId: "2813",
        treeSpecies: "Red Maple",
        treeDiameter: "50 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.86828, -87.650921],
      },
      {
        name: "Sap_Flow_Meter_SX61NA0W",
        serialNumber: "SX61NA0W",
        devEUI: "3A840CEDE9E03F6E",
        treeId: "1722",
        treeSpecies: "American Elm",
        treeDiameter: "30.2 inches",
        type: "Sap Flow Sensor",
        coordinates: [41.86955, -87.64588],
      },
      {
        name: "Band_Dendrometer_SNLA4P303",
        serialNumber: "SNLA4P303",
        devEUI: "98208e00000346eb",
        treeId: "2867",
        treeSpecies: "Maple",
        treeDiameter: "57.8 inches",
        type: "Band Dendrometer",
        coordinates: [41.86810862, -87.64869461],
      },
      {
        name: "WXT536_Sensor_WXT-UIC",
        serialNumber: "WXT-UIC",
        devEUI: "",
        site: "Greenhouse",
        type: "WXT536 Sensor",
        coordinates: [41.868532807, -87.64589484],
      },
      {
        name: "AQT530_Sensor_AQT-UIC",
        serialNumber: "AQT-UIC",
        devEUI: "",
        site: "Greenhouse",
        type: "AQT530 Sensor",
        coordinates: [41.868532807, -87.64589484],
      },
    ],
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  {
    name: "HUM",
    fullName: "Humboldt Park",
    city: "Chicago",
    siteType: "Urban Park",
    coordinates: [41.905586865, -87.70355311],
    mfrNodes: ["MNLA4O10F", "MNLA4O10G"],
    sapFlowMeters: [],
    overview: {
      registration: "2025",
    },
    devices: [
      {
        name: "MFR_node_MNLA4O10F",
        serialNumber: "MNLA4O10F",
        devEUI: "",
        site: "Prairie",
        type: "MFR Node",
        coordinates: [41.907846, -87.705554],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },
      {
        name: "MFR_node_MNLA4O10G",
        serialNumber: "MNLA4O10G",
        devEUI: "",
        site: "Turf",
        type: "MFR Node",
        coordinates: [41.908222, -87.705921],
        attachedSensors: ["ATH-VPD", "HFP01-05", "SN500", "Teros54", "Hydros21"],
      },
      {
        name: "WXT536_Sensor_WXT-HUM",
        serialNumber: "WXT-HUM",
        devEUI: "",
        site: "Turf",
        type: "WXT536 Sensor",
        coordinates: [41.905586865, -87.70355311],
      },
      {
        name: "AQT530_Sensor_AQT-HUM",
        serialNumber: "AQT-HUM",
        devEUI: "",
        site: "Turf",
        type: "AQT530 Sensor",
        coordinates: [41.905586865, -87.70355311],
      },
    ],
    sitePhotos: [
      { url: "/HUM/HUM_Waggle_Node.jpg", caption: "Waggle Node" },
      { url: "/HUM/HUM_Prairie.jpeg", caption: "Prairie" },
      { url: "/HUM/HUM_Turf.jpeg", caption: "Turf" }
    ]
  },
  {
    name: "SHEDD",
    fullName: "Shedd Aquarium",
    city: "Chicago",
    siteType: "Urban",
    coordinates: [41.868164164, -87.613424455],
    mfrNodes: [],
    sapFlowMeters: [],
    overview: {
      registration: "2025",
    },
    devices: [
      {
        name: "WXT536_Sensor_WXT-SHEDD",
        serialNumber: "WXT-SHEDD",
        devEUI: "",
        site: "Rooftop",
        type: "WXT536 Sensor",
        coordinates: [41.868164164, -87.613424455],
      },
      {
        name: "AQT530_Sensor_AQT-SHEDD",
        serialNumber: "AQT-SHEDD",
        devEUI: "",
        site: "Rooftop",
        type: "AQT530 Sensor",
        coordinates: [41.868164164, -87.613424455],
      },
    ],
    sitePhotos: []
  },
  {
    name: "CCICS",
    fullName: "NEIU Carruthers Center",
    city: "Chicago",
    siteType: "Urban",
    coordinates: [41.822951506, -87.609693291],
    mfrNodes: [],
    sapFlowMeters: [],
    overview: {
      registration: "2025",
    },
    devices: [
      {
        name: "WXT536_Sensor_WXT-CCICS",
        serialNumber: "WXT-CCICS",
        devEUI: "",
        site: "Rooftop",
        type: "WXT536 Sensor",
        coordinates: [41.822951506, -87.609693291],
      },
      {
        name: "AQT530_Sensor_AQT-CCICS",
        serialNumber: "AQT-CCICS",
        devEUI: "",
        site: "Rooftop",
        type: "AQT530 Sensor",
        coordinates: [41.822951506, -87.609693291],
      },
    ],
    sitePhotos: []
  },
];

// Static location metadata (coordinates, names, etc.) - kept for backwards compatibility
export const locationMetadata = {
  "BIG": {
    fullName: "West Woodlawn",
    city: "Chicago",
    siteType: "Urban Park",
    coordinates: [41.777021702, -87.609711317],
    overview: { registration: "9/20/2023, 12:10:34 PM" },
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  "CSU": {
    fullName: "Chicago State University",
    city: "Chicago",
    siteType: "Urban",
    coordinates: [41.71995827, -87.612900518],
    overview: { registration: "6/13/2022, 1:28:01 PM" },
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  "IBP": {
    fullName: "Indian Boundary Prairies",
    city: "Markham",
    siteType: "Suburban",
    coordinates: [41.608145186, -87.704647595],
    overview: { registration: "5/14/2025, 9:47:28 AM" },
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  "NEIU": {
    fullName: "Northeastern Illinois University",
    city: "Chicago",
    siteType: "Urban",
    coordinates: [41.98053299237866, -87.71662374616044],
    overview: { registration: "6/13/2022, 1:28:01 PM" },
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  "NU": {
    fullName: "Northwestern University",
    city: "Evanston",
    siteType: "Suburban",
    coordinates: [42.05142506, -87.677642818],
    overview: { registration: "6/13/2022, 1:28:01 PM" },
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  "UIC": {
    fullName: "University of Illinois Chicago",
    city: "Chicago",
    siteType: "Urban",
    coordinates: [41.869384335, -87.645820232],
    overview: { registration: "9/6/2023, 12:39:08 PM" },
    sitePhotos: [
      { url: "/BIG/IMG_1049.jpeg", caption: "Prairie" },
      { url: "/BIG/IMG_1154.jpeg", caption: "MFR Node" },
      { url: "/BIG/IMG_3956.jpeg", caption: "Sap Flow Sensors" }
    ]
  },
  "HUM": {
    fullName: "Humboldt Park",
    city: "Chicago",
    siteType: "Urban Park",
    coordinates: [41.905586865, -87.70355311],
    overview: { registration: "2025" },
    sitePhotos: []
  },
  "SHEDD": {
    fullName: "Shedd Aquarium",
    city: "Chicago",
    siteType: "Urban",
    coordinates: [41.868164164, -87.613424455],
    overview: { registration: "2025" },
    sitePhotos: []
  },
  "CCICS": {
    fullName: "NEIU Carruthers Center",
    city: "Chicago",
    siteType: "Urban",
    coordinates: [41.822951506, -87.609693291],
    overview: { registration: "2025" },
    sitePhotos: []
  }
};

export const devicesData = [
  // {
  //   manufacturer: "Rakwireless",
  //   model: "WisGate Edge Pro",
  //   name: "LoRaWAN Gateway",
  //   description: "The WisGate Edge Pro is an LPWAN Concentrator Module with mini-PCIe form factor based on Semtech SX1302, which enables easy integration into existing routers or other network equipment.",
  //   fullDescription: "The WisGate Edge Pro is an industrial-grade LoRaWAN gateway featuring 8-channel capability with US915 frequency support and LTE connectivity. It provides reliable, long-range wireless communication for IoT deployments in urban and industrial environments.",
  //   locationCount: 6,  // UPDATED
  //   readMore: true
  // },
  {
    manufacturer: "ICT International",
    model: "MFR_node",
    name: "Multi-Function Research LoRaWAN Node",
    description: "The MFR-NODE is a data logger designed to provide flexible communication, sensor and power options. Supports SDI-12, four 32-bit dry-contact counting digital inputs and four single-ended (two differential) 0-3V analogue inputs.",
    locationCount: 6,  // UPDATED
    readMore: true
  },
  {
    manufacturer: "ICT International",
    model: "SFM1x",
    name: "SFM1x Sap Flow Meter",
    description: "The SFM1x Sap Flow Meter enables individual tree water use and health monitoring in real time using the Heat Ratio Method to measure high, low, zero and reverse flows.",
    locationCount: 5  // UPDATED
  },
  {
    manufacturer: "ICT International",
    model: "Band_Dendrometer",
    name: "Band Dendrometer",
    description: "Precision dendrometer bands for continuous monitoring of tree growth and circumference changes, providing insights into tree water status and growth patterns.",
    locationCount: 4  // UPDATED
  },
  {
    manufacturer: "Meter Group",
    model: "ATH-VPD",
    name: "Air Temperature & Humidity Sensor",
    description: "High-precision sensor for measuring air temperature, relative humidity, and calculating vapor pressure deficit in environmental monitoring applications.",
    locationCount: 6  // UPDATED
  },
  {
    manufacturer: "Hukseflux",
    model: "HFP01-05",
    name: "Heat Flux Plate",
    description: "Self-calibrating heat flux sensor for measuring soil heat flux in agricultural and meteorological applications.",
    locationCount: 6  // UPDATED
  },
  {
    manufacturer: "Apogee Instruments",
    model: "SN500",
    name: "4-Component Net Radiometer",
    description: "Measures incoming and outgoing shortwave and longwave radiation for complete radiation balance assessment.",
    locationCount: 6  // UPDATED
  },
  {
    manufacturer: "Meter Group",
    model: "Teros54",
    name: "Soil Moisture & Temperature Profile",
    description: "Multi-depth soil sensor measuring volumetric water content and temperature at four depths for comprehensive soil profile monitoring.",
    locationCount: 6  // UPDATED
  },
  {
    manufacturer: "Meter Group",
    model: "Hydros21",
    name: "Water Level, Temperature & Conductivity",
    description: "Submersible sensor for continuous monitoring of water depth, temperature, and electrical conductivity in surface water and groundwater applications.",
    locationCount: 5  // UPDATED
  },
  {
    manufacturer: "Vaisala",
    model: "WXT536",
    name: "WXT536 Weather Sensor",
    description: "Multi-parameter weather sensor measuring temperature, humidity, barometric pressure, wind speed/direction, and precipitation (rain and hail accumulation).",
    locationCount: 8
  },
  {
    manufacturer: "Vaisala",
    model: "AQT530",
    name: "AQT530 Air Quality Sensor",
    description: "Compact air quality sensor measuring gas concentrations (CO, NO, NO₂, O₃) and particulate matter (PM1, PM2.5, PM10) along with temperature, humidity, and pressure.",
    locationCount: 8
  }
];

// Ontology data
export const ontologyData = {
  air_temperature: {
    name: "Air Temperature",
    units: "°C",
    description: "Ambient air temperature measured at sensor height",
    range: "-40 to 60°C",
    accuracy: "±0.3°C",
    sensor: "ATH-VPD"
  },
  barometric_pressure: {
    name: "Barometric Pressure",
    units: "hPa",
    description: "Atmospheric pressure at sensor location",
    range: "500 to 1100 hPa",
    accuracy: "±0.5 hPa",
    sensor: "Built-in barometer"
  },
  relative_humidity: {
    name: "Relative Humidity",
    units: "%",
    description: "Relative humidity of air",
    range: "0 to 100%",
    accuracy: "±2%",
    sensor: "ATH-VPD"
  },
  vapour_pressure_deficit: {
    name: "Vapour Pressure Deficit",
    units: "kPa",
    description: "Difference between saturation vapor pressure and actual vapor pressure",
    range: "0 to 10 kPa",
    accuracy: "Calculated",
    sensor: "Derived from ATH-VPD"
  },
  heat_flux: {
    name: "Heat Flux",
    units: "W/m²",
    description: "Soil heat flux density",
    range: "-200 to 200 W/m²",
    accuracy: "±3%",
    sensor: "HFP01-05"
  },
  water_conductivity: {
    name: "Water Conductivity",
    units: "μS/cm",
    description: "Electrical conductivity of water",
    range: "0 to 5000 μS/cm",
    accuracy: "±5%",
    sensor: "Hydros21"
  },
  water_depth: {
    name: "Water Depth",
    units: "mm",
    description: "Water level or depth measurement",
    range: "0 to 5000 mm",
    accuracy: "±5 mm",
    sensor: "Hydros21"
  },
  water_temperature: {
    name: "Water Temperature",
    units: "°C",
    description: "Temperature of water body",
    range: "-40 to 80°C",
    accuracy: "±0.1°C",
    sensor: "Hydros21"
  },
  uncorrected_inner: {
    name: "Uncorrected Inner Sap Flow",
    units: "mL/h",
    description: "Inner probe sap flow measurement (uncorrected)",
    range: "Variable",
    accuracy: "±10%",
    sensor: "SFM1x"
  },
  uncorrected_outer: {
    name: "Uncorrected Outer Sap Flow",
    units: "mL/h",
    description: "Outer probe sap flow measurement (uncorrected)",
    range: "Variable",
    accuracy: "±10%",
    sensor: "SFM1x"
  },
  battery_voltage: {
    name: "Battery Voltage",
    units: "V",
    description: "Device battery voltage",
    range: "0 to 5 V",
    accuracy: "±0.01 V",
    sensor: "Internal"
  },
  solar_voltage: {
    name: "Solar Panel Voltage",
    units: "V",
    description: "Solar panel output voltage",
    range: "0 to 20 V",
    accuracy: "±0.01 V",
    sensor: "Internal"
  },
  vwc_d1: {
    name: "Volumetric Water Content D1",
    units: "m³/m³",
    description: "Soil volumetric water content at depth 1",
    range: "0 to 1 m³/m³",
    accuracy: "±0.03 m³/m³",
    sensor: "Teros54"
  },
  temp_d1: {
    name: "Soil Temperature D1",
    units: "°C",
    description: "Soil temperature at depth 1",
    range: "-40 to 60°C",
    accuracy: "±1°C",
    sensor: "Teros54"
  },
  vwc_d2: {
    name: "Volumetric Water Content D2",
    units: "m³/m³",
    description: "Soil volumetric water content at depth 2",
    range: "0 to 1 m³/m³",
    accuracy: "±0.03 m³/m³",
    sensor: "Teros54"
  },
  temp_d2: {
    name: "Soil Temperature D2",
    units: "°C",
    description: "Soil temperature at depth 2",
    range: "-40 to 60°C",
    accuracy: "±1°C",
    sensor: "Teros54"
  },
  vwc_d3: {
    name: "Volumetric Water Content D3",
    units: "m³/m³",
    description: "Soil volumetric water content at depth 3",
    range: "0 to 1 m³/m³",
    accuracy: "±0.03 m³/m³",
    sensor: "Teros54"
  },
  temp_d3: {
    name: "Soil Temperature D3",
    units: "°C",
    description: "Soil temperature at depth 3",
    range: "-40 to 60°C",
    accuracy: "±1°C",
    sensor: "Teros54"
  },
  vwc_d4: {
    name: "Volumetric Water Content D4",
    units: "m³/m³",
    description: "Soil volumetric water content at depth 4",
    range: "0 to 1 m³/m³",
    accuracy: "±0.03 m³/m³",
    sensor: "Teros54"
  },
  temp_d4: {
    name: "Soil Temperature D4",
    units: "°C",
    description: "Soil temperature at depth 4",
    range: "-40 to 60°C",
    accuracy: "±1°C",
    sensor: "Teros54"
  },
  in_longwave: {
    name: "Incoming Longwave Radiation",
    units: "W/m²",
    description: "Incoming thermal/infrared radiation",
    range: "0 to 1000 W/m²",
    accuracy: "±10%",
    sensor: "SN500"
  },
  in_shortwave: {
    name: "Incoming Shortwave Radiation",
    units: "W/m²",
    description: "Incoming solar radiation",
    range: "0 to 1400 W/m²",
    accuracy: "±5%",
    sensor: "SN500"
  },
  out_longwave: {
    name: "Outgoing Longwave Radiation",
    units: "W/m²",
    description: "Outgoing thermal/infrared radiation",
    range: "0 to 1000 W/m²",
    accuracy: "±10%",
    sensor: "SN500"
  },
  out_shortwave: {
    name: "Outgoing Shortwave Radiation",
    units: "W/m²",
    description: "Reflected solar radiation",
    range: "0 to 1400 W/m²",
    accuracy: "±5%",
    sensor: "SN500"
  },
  "wxt.env.temp": {
    name: "WXT Temperature",
    units: "°C",
    description: "Air temperature measured by WXT536 weather sensor",
    range: "-52 to 60°C",
    accuracy: "±0.3°C",
    sensor: "WXT536"
  },
  "wxt.env.humidity": {
    name: "WXT Humidity",
    units: "%",
    description: "Relative humidity measured by WXT536 weather sensor",
    range: "0 to 100%",
    accuracy: "±3%",
    sensor: "WXT536"
  },
  "wxt.env.pressure": {
    name: "WXT Pressure",
    units: "hPa",
    description: "Barometric pressure measured by WXT536 weather sensor",
    range: "600 to 1100 hPa",
    accuracy: "±0.5 hPa",
    sensor: "WXT536"
  },
  "wxt.wind.speed": {
    name: "WXT Wind Speed",
    units: "m/s",
    description: "Wind speed measured by WXT536 ultrasonic wind sensor",
    range: "0 to 60 m/s",
    accuracy: "±3%",
    sensor: "WXT536"
  },
  "wxt.wind.direction": {
    name: "WXT Wind Direction",
    units: "°",
    description: "Wind direction measured by WXT536 ultrasonic wind sensor",
    range: "0 to 360°",
    accuracy: "±3°",
    sensor: "WXT536"
  },
  "wxt.rain.accumulation": {
    name: "WXT Rain Accumulation",
    units: "mm",
    description: "Cumulative rainfall accumulation measured by WXT536",
    range: "Variable",
    accuracy: "±5%",
    sensor: "WXT536"
  },
  "wxt.hail.accumulation": {
    name: "WXT Hail Accumulation",
    units: "mm",
    description: "Cumulative hail accumulation measured by WXT536",
    range: "Variable",
    accuracy: "±5%",
    sensor: "WXT536"
  },
  "wxt.heater.temp": {
    name: "WXT Heater Temperature",
    units: "°C",
    description: "Internal heater temperature of WXT536 sensor",
    range: "Variable",
    accuracy: "±0.3°C",
    sensor: "WXT536"
  },
  "wxt.heater.volt": {
    name: "WXT Heater Voltage",
    units: "V",
    description: "Heater supply voltage of WXT536 sensor",
    range: "0 to 24 V",
    accuracy: "±0.1 V",
    sensor: "WXT536"
  },
  "wxt.heater.status": {
    name: "WXT Heater Status",
    units: "Unitless",
    description: "Heater operational status of WXT536 sensor",
    range: "Variable",
    accuracy: "N/A",
    sensor: "WXT536"
  },
  "aqt.env.temp": {
    name: "AQT Temperature",
    units: "°C",
    description: "Air temperature measured by AQT530 air quality sensor",
    range: "-40 to 60°C",
    accuracy: "±0.3°C",
    sensor: "AQT530"
  },
  "aqt.env.humidity": {
    name: "AQT Humidity",
    units: "RH",
    description: "Relative humidity measured by AQT530 air quality sensor",
    range: "0 to 100 RH",
    accuracy: "±3%",
    sensor: "AQT530"
  },
  "aqt.env.pressure": {
    name: "AQT Pressure",
    units: "hPa",
    description: "Barometric pressure measured by AQT530 air quality sensor",
    range: "600 to 1100 hPa",
    accuracy: "±0.5 hPa",
    sensor: "AQT530"
  },
  "aqt.gas.co": {
    name: "Carbon Monoxide (CO)",
    units: "PPM",
    description: "Carbon monoxide concentration measured by AQT530",
    range: "0 to 200 PPM",
    accuracy: "±0.02 PPM",
    sensor: "AQT530"
  },
  "aqt.gas.no": {
    name: "Nitric Oxide (NO)",
    units: "PPM",
    description: "Nitric oxide concentration measured by AQT530",
    range: "0 to 20 PPM",
    accuracy: "±0.02 PPM",
    sensor: "AQT530"
  },
  "aqt.gas.no2": {
    name: "Nitrogen Dioxide (NO₂)",
    units: "PPM",
    description: "Nitrogen dioxide concentration measured by AQT530",
    range: "0 to 20 PPM",
    accuracy: "±0.02 PPM",
    sensor: "AQT530"
  },
  "aqt.gas.ozone": {
    name: "Ozone (O₃)",
    units: "PPM",
    description: "Ozone concentration measured by AQT530",
    range: "0 to 20 PPM",
    accuracy: "±0.02 PPM",
    sensor: "AQT530"
  },
  "aqt.particle.pm1": {
    name: "PM1",
    units: "μg/m³",
    description: "Particulate matter ≤1 μm measured by AQT530",
    range: "0 to 1500 μg/m³",
    accuracy: "±10 μg/m³",
    sensor: "AQT530"
  },
  "aqt.particle.pm2.5": {
    name: "PM2.5",
    units: "μg/m³",
    description: "Particulate matter ≤2.5 μm measured by AQT530",
    range: "0 to 1500 μg/m³",
    accuracy: "±10 μg/m³",
    sensor: "AQT530"
  },
  "aqt.particle.pm10": {
    name: "PM10",
    units: "μg/m³",
    description: "Particulate matter ≤10 μm measured by AQT530",
    range: "0 to 1500 μg/m³",
    accuracy: "±10 μg/m³",
    sensor: "AQT530"
  }
};